module.exports = __webpack_public_path__ + "media/images/social/vv_05-7a786913a2c19fac53adf1688a322edb.jpg";